<!--This component only exists to mantain consistency between our aplication
and the correspondent contract on the openAPI-->
<template>
  <div>
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <!-- ComponentData needs to exist in order for the slot-component-data to work -->
    <SlotContainer
      v-if="componentData.tabIndex || isEditMode"
      refName="slot-tab-item"
      class="owc-tabs-item__content"
      :slot-component-data="JSON.stringify({ componentData })"
    >
      <slot></slot>
    </SlotContainer>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

/**
 * `Tab Item` - This component represents an item for the tabs component (as in a placeholder).
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-tab-item',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
});
</script>

<style lang="scss">
.owc-tabs-item__content {
  margin-top: var(--wb-spacing-s);
}
</style>
